import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConcurrentRequestHandlingService } from '@modules/common/services/concurrent-request-handling.service';
import { ApiProxyOptions } from '@modules/common/models/api-proxy-options';
import { GetPhoneCallParticipantInfoArgs } from './get-phone-call-participant-info-args.generated';
import { GetPhoneCallParticipantInfoResult } from './get-phone-call-participant-info-result.generated';

@Injectable({
    providedIn: 'root'
})
export class GetPhoneCallParticipantInfoService {
    constructor(private _concurrentRequestHandlingService: ConcurrentRequestHandlingService) { }

    public getPhoneCallParticipantInfo(args: GetPhoneCallParticipantInfoArgs, options?: ApiProxyOptions): Observable<GetPhoneCallParticipantInfoResult> {
        return this._concurrentRequestHandlingService.callApi<GetPhoneCallParticipantInfoResult>(
            "GetPhoneCallParticipantInfoService_getPhoneCallParticipantInfo",
            {
                url: '/Participant/GetPhoneCallParticipantInfo/GetPhoneCallParticipantInfo',
                body: typeof args === 'undefined' || args === null ? {} : args,
                sendCredentials: true
            }, options
        );
    }
}
